<template>
    <div @click="showPopupBool = true" v-if="options?.directMode !== true && options?.button !== false">
        <slot>Create a Text for the button</slot>
    </div>
    <Transition>
        <div @click.self="hide()" class="overlay" v-show="showPopup">
            <div class="popup-window" :class="{'popup-window-default': !noStyle}" v-bind="$attrs">
                <header>
                    <h4>{{ header }}</h4>
                    <a class="btn" @click="hide()">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="#1C1C1E" xmlns="http://www.w3.org/2000/svg" style="filter: invert(1);">
                        <path d="M7.18849 19.0508C6.81935 19.4199 6.80177 20.0791 7.19728 20.4658C7.58399 20.8525 8.24317 20.8438 8.61231 20.4746L13.9912 15.0869L19.3789 20.4746C19.7568 20.8525 20.4072 20.8525 20.794 20.4658C21.1719 20.0703 21.1807 19.4287 20.794 19.0508L15.415 13.6631L20.794 8.28419C21.1807 7.90626 21.1807 7.25587 20.794 6.86915C20.3984 6.49122 19.7568 6.48243 19.3789 6.86036L13.9912 12.2481L8.61231 6.86036C8.24317 6.49122 7.5752 6.47364 7.19728 6.86915C6.81056 7.25587 6.81935 7.91505 7.18849 8.28419L12.5762 13.6631L7.18849 19.0508Z"/>
                    </svg>
                    </a>
                </header>
                <div class="popup-container">
                    <slot name="body">Add elements by using template v-slot:body</slot>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { computed, ref } from 'vue'
/* eslint-disable */
// import { ref } from 'vue'
// const showPopup = ref(false)

defineOptions({
    inheritAttrs: false
})

const emit = defineEmits(['close'])

const props = defineProps({
    show: Boolean,
    options: Object,
    header: String,
    noStyle: {
        type: Boolean,
        default: false
    }
})

const showPopupBool = ref(false)

const showPopup = computed(() => {
    if(typeof props.show === 'boolean') return props.show
    else return showPopupBool.value
})

const hide = () => {
    if(props?.options?.directMode === true) emit('close')
    if(typeof props.show === 'boolean') emit('close')
    showPopupBool.value = false
}

</script>

<style scoped>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--var-backdrop), 0.6);
  z-index: 99;
}
.popup-window {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.popup-window-default {
  width: 65%;
  min-height: 250px;
  max-height: calc(100vh - 100px);
  min-width: 160px;
  max-width: calc(300px + 4rem);
  padding: 1rem 0;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
}
.popup-window-default > * {
  padding: 0 1.5rem;
}
.popup-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;
  padding: 0;
}
header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
